// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-add-entities {\n  position: absolute;\n}[dir=ltr] .button-add-entities {\n  right: 1px;\n}[dir=rtl] .button-add-entities {\n  left: 1px;\n}\n", ""]);
// Exports
module.exports = exports;
